import { css } from "@emotion/css";
import React from "react";
import LayoutChild from "../DesignSystem/Layout/LayoutChild";
import LayoutCol from "../DesignSystem/Layout/LayoutCol";
import LayoutContainer from "../DesignSystem/Layout/LayoutContainer";

const loading = css`
  border: 12px solid #ecf5fe; /* Light grey */
  border-top: 12px solid #cb99db; /* Blue */
  border-radius: 50%;
  width: 110px;
  height: 110px;
  animation: spin 1.5s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const PageLoader: React.FC = (props) => {
  return (
    <LayoutContainer
      className={css`
        position: absolute;
        top: 0;
        bottom: 0;
      `}
      center={true}
    >
      <LayoutCol
        className={css`
          height: 100%;
        `}
        alignY="center"
      >
        <LayoutChild grow={1} />
        <div className={loading}></div>
        <LayoutChild grow={1} />
      </LayoutCol>
    </LayoutContainer>
  );
};

export default PageLoader;
